export { default as Style } from './page'


// WEBPACK FOOTER //
// ./src/pages/Style/index.js